import script from "./StockTransactions.vue?vue&type=script&setup=true&lang=js"
export * from "./StockTransactions.vue?vue&type=script&setup=true&lang=js"

import "./StockTransactions.vue?vue&type=style&index=0&id=6f230919&lang=css"

const __exports__ = script;

export default __exports__